var logo = require('../../assets/img/subiz-mono.svg')
import store from '@sb/store'

export default {
	name: 'PoweredBy',
	render () {
		let user = store.matchUser()
		var link = `https://subiz.com/?utm_source=id-${user.account_id}&utm_medium=widget&utm_campaign=widget_referral`

		return (
			<div class="poweredby">
				<a href={link} class="poweredby--text" target="_blank">
					<img class="poweredby--subiz-logo" src={logo} alt /> Subiz
				</a>
			</div>
		)
	},
}
